import { getSkill, Skill, skills } from "../skills/config";

import AiNftify from "./../../images/ai-nftify.jpg";
import Allaccess from "./../../images/all-access.jpeg";
import Avss from "./../../images/avss.png"

export type Project = {
  name: string,
  description: string,
  image: any,
  url: string,
  github: string,
  technologies: Skill[],
}

export const projects: Project[] = [
  {
    name: "AI NFTify",
    description: "Where AI meets Blockchain to revolutionize the NFT landscape. Discover, create, and trade AI-generated digital assets securely on the Bitcoin and Rootstock chains.",
    image: AiNftify,
    url: "https://www.youtube.com/watch?v=kcSHt7Aa1H8&t=1s",
    github: "https://github.com/SnowyField1906/nft-generator",
    technologies: getSkill(["react", "nestJS", "typescript", "solidity", "javascript", "azure"])
  },
  {
    name: "AllAccess Wallet",
    description: "Flow network's crypto wallets have two major challenges: user complexity with extension and mobile wallets, and reliance on centralized solutions like Dapper and Blocto. Our solution, AANodes and AllAccess Wallet, inspired by Torus and the WAX Cloud Wallet, aims to simplify usability and promote decentralization on Flow.",
    image: Allaccess,
    url: "https://www.youtube.com/watch?v=cveQR3wF9Xk",
    github: "https://github.com/AllAccessOne",
    technologies: getSkill(["react", "nest", "typescript", "mongodb", "docker"])
  },
  {
    name: "Asynchronous Verifiable Secret Sharing",
    description: "The operation of the Shamir's Secret Sharing (SSS), Distributed Key Generation (DKG), Lagrange Interpolation (LI), and Asynchronous Verifiable Secret Sharing (AVSS) algorithms.",
    image: Avss,
    url: "",
    github: "https://github.com/Kiet1618/AVSS",
    technologies: getSkill(["typescript"])
  }
];